"use client";
import { component } from "@gnist/component-utils/componentFactories.js";
import { textBelowInputRecipe } from "./textBelowInput.css.js";
const TextBelowInput = component("TextBelowInput", textBelowInputRecipe, "div");
export {
  TextBelowInput
};
